<section class="py-5" id="acceptable-use">
  <div class="container mb-5">
    <h2 class="h1 my-5">Acceptable Use</h2>
    <div class="row gx-5">

      <div class="col-12 col-lg-4">
        <h2 class="h3">Students</h2>
        <p class="fs-5">
          Students enrolled part-time or full-time in a degree-granting program
          or an academic course of study conducted by the university
          are permitted to download, install, activate, and use
          this software for university academic purposes.
          This includes students enrolled at the University of Utah Asia Campus.
        </p>

        <p class="fs-5">
          You may install and use as many or as few applications as you like,
          as long as you meet the eligibility requirements.
          If you receive an error message indicating your trial has expired,
          please contact the Help Desk at 801-581-4000,&nbsp;ext.&nbsp;1.
        </p>

        <p class="fs-5">
          This software can be deployed only in the United States, Canada, Mexico, or South Korea.
          International Study Abroad students are not eligible to participate in this program.
        </p>
      </div>

      <div class="col-12 col-lg-4">
        <h2 class="h3">Faculty / Staff / Emeriti</h2>
        <p class="fs-5">
          All current full-time employees or affiliates (independent contractors)
          whose primary job duties consist of providing educational instructions
          to students or current full-time employees that provide administrative support
          to the education operations of faculty.
          Affiliates who are eligible to use the software need to request access
          by sending email to
          <a href="mailto:classhelp@utah.edu">classhelp&#64;utah.edu</a>
          with your name, uNID, and the product needed
          (Adobe Express or Adobe All Apps Pro).
        </p>

        <p class="fs-5">
          Board of Trustees-appointed emeriti may request access to
          Adobe products after retirement by emailing
          <a href="mailto:classhelp@utah.edu">classhelp&#64;utah.edu</a>
          with uNID and name.
        </p>

        <p class="fs-5">
          Retired faculty and staff members are not eligible.
        </p>
      </div>

      <div class="col-12 col-lg-4">
        <h2 class="h3">IT Administrators</h2>
        <p class="fs-5">
          <a href="https://helpx.adobe.com/enterprise/using/sdl-deployment-guide.html">Shared Device Licensing</a>
          is a licensing model to deploy and manage Adobe applications
          in labs and shared device setups,
          where multiple users use the devices and applications.
          The software license is assigned to a device or computer instead of an individual.
          Shared Device Licensing is ideal for computers in your labs or classrooms.
          Shared Device Licensing is not designed for use on machines used by dedicated users.
        </p>

        <p class="fs-5">
          If you are an IT administrator
          who needs to install shared devices licenses
          in computer labs or computer classrooms,
          please send an email to
          <a href="mailto:classhelp@utah.edu">classhelp&#64;utah.edu</a>
          to request access to the install files.
          Include your first and last name, uNID, and department.
        </p>
      </div>
    </div>
  </div>
</section>
